var _excluded = ["styleConfig"],
  _excluded2 = ["style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { filterUndefined, memoisedGet as get, mergeWith, runIfFn, omit } from '../utils';
import { useMemo, useRef } from 'react';
import isEqual from 'react-fast-compare';
import { useTheme } from './hooks';
export function useStyleConfig(themeKey) {
  var _styleConfig$defaultP;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var {
      styleConfig: styleConfigProp
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var themeStyleConfig = get(theme, "components.".concat(themeKey));
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme
  }, (_styleConfig$defaultP = styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.defaultProps) !== null && _styleConfig$defaultP !== void 0 ? _styleConfig$defaultP : {}, filterUndefined(omit(rest, ['children'])));

  /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */

  var stylesRef = useRef({});
  return useMemo(() => {
    if (styleConfig) {
      var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$colorSch, _styleConfig$colorSch2, _styleConfig$sizes$me, _styleConfig$sizes;
      var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) !== null && _styleConfig$baseStyl !== void 0 ? _styleConfig$baseStyl : {}, mergedProps);
      var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) === null || _styleConfig$variants2 === void 0 ? void 0 : _styleConfig$variants2[mergedProps.variant]) !== null && _styleConfig$variants !== void 0 ? _styleConfig$variants : {}, mergedProps);
      var colorSchemes = runIfFn((_styleConfig$colorSch = (_styleConfig$colorSch2 = styleConfig.colorSchemes) === null || _styleConfig$colorSch2 === void 0 ? void 0 : _styleConfig$colorSch2[mergedProps.colorScheme]) !== null && _styleConfig$colorSch !== void 0 ? _styleConfig$colorSch : {}, mergedProps);
      var sizes = runIfFn((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) === null || _styleConfig$sizes === void 0 ? void 0 : _styleConfig$sizes[mergedProps.size]) !== null && _styleConfig$sizes$me !== void 0 ? _styleConfig$sizes$me : {}, mergedProps);
      var _omit = (obj, keys) => {
        if (!keys.length) return obj;
        var key = keys.pop();
        if (!key) {
          return obj;
        }
        var parts = key.split('.');
        if (parts.length > 1) {
          var _parts$ = parts[0],
            {
              [_parts$]: todo
            } = obj,
            _rest = _objectWithoutProperties(obj, [_parts$].map(_toPropertyKey));
          return _objectSpread(_objectSpread({}, _omit(_rest, keys)), {}, {
            [parts[0]]: _omit(todo, [parts[1]])
          });
        }
        var {
            [key]: omitted
          } = obj,
          rest = _objectWithoutProperties(obj, [key].map(_toPropertyKey));
        return _omit(rest, keys);
      };

      /**
       * Allows styles to be applied when the user passes multiple modifiers simultaneously.
       */
      var compoundModifiers = config => {
        var styles = [];
        var matched = config === null || config === void 0 ? void 0 : config.filter(_ref => {
          var {
              style: _
            } = _ref,
            modifiers = _objectWithoutProperties(_ref, _excluded2);
          var propsToFilter = ['style'];
          var keys = Object.keys(modifiers).filter(key => !propsToFilter.includes(key));
          return keys.every(modifierKey => {
            return modifiers[modifierKey] === mergedProps[modifierKey];
          });
        });
        matched === null || matched === void 0 ? void 0 : matched.forEach(obj => obj.style ? styles.push(obj.style) : null);
        return mergeWith({}, ...styles);
      };
      var compoundedModifiers = compoundModifiers(styleConfig.compoundModifiers);
      var styles = mergeWith({}, baseStyles, sizes, variants, colorSchemes, compoundedModifiers);
      if (opts !== null && opts !== void 0 && opts.isMultiPart && styleConfig.parts) {
        styleConfig.parts.forEach(part => {
          var _styles$part;
          styles[part] = (_styles$part = styles[part]) !== null && _styles$part !== void 0 ? _styles$part : {};
        });
      }
      var isStyleEqual = isEqual(stylesRef.current, styles);
      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }
    return stylesRef.current;
  }, [styleConfig, mergedProps, opts === null || opts === void 0 ? void 0 : opts.isMultiPart]);
}
export function useMultiStyleConfig(themeKey, props) {
  return useStyleConfig(themeKey, props, {
    isMultiPart: true
  });
}